import { cn } from "@/lib/utils";

export function PageFrame({
  children,
  size = "fluid",
  scrollable = false,
  className,
}: {
  children: React.ReactNode;
  size?: "fluid" | "form";
  scrollable?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "mx-auto flex h-full min-h-0 w-full flex-1 flex-col gap-4",
        size === "form" && "max-w-[960px]",
        (scrollable || size === "form") && "overflow-y-auto console-scrollbar pr-1 pb-10",
        className,
      )}
    >
      {children}
    </div>
  );
}
